<template>
    <div>
        <header>
            <div class="header-title">
                <div style="display: flex; align-items: center;">
                    <p>问题描述列表</p>
                </div>
            </div>
        </header>
        <div class="container">
            <div style="background: #fff;padding: 20px;min-height: 700px">
                <div class="card-content-search">
                    <button class="card-content-search-add" v-debounce="[addData,'click',500]"><i class="el-icon-plus" style="margin: 0 5px"></i>新增</button>
                </div>
                <el-table
                        border
                        :data="tableList"
                        :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                        }">
                    <el-table-column
                            fixed
                            prop="date"
                            type="index"
                            label="序号"
                            align="center"
                            width="60px">
                        <template scope="scope">
                            <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            label="操作"
                            align="center"
                            width="300">
                        <template scope="scope">
                            <el-button @click="toDetail(scope.row)" size="small">查看</el-button>
                            <el-button @click="toQuestionExit(scope.row)" size="small">编辑</el-button>
                            <el-button v-if="!scope.row.publishFlag" type="primary" @click="publishToPage(scope.row,'发布')" size="small">发布</el-button>
                            <el-button v-else type="" @click="publishToPage(scope.row,'取消发布')" size="small">取消发布</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            align="center"
                            label="发布状态">
                        <template scope="scope">
                            <span v-if="scope.row.publishFlag" >已发布</span>
                            <span v-else style="color: red">待发布</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="sortNo"
                            align="center"
                            label="排序"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="title"
                            align="center"
                            label="标题">
                    </el-table-column>
                    <el-table-column
                            prop="updateUser"
                            align="center"
                            label="编辑人"
                            width="155">
                    </el-table-column>
                    <el-table-column
                            prop="updateTime"
                            align="center"
                            label="编辑时间"
                            width="155">
                    </el-table-column>
                    <el-table-column
                            prop="content"
                            align="center"
                            label="修改人"
                            width="155">
                    </el-table-column>
                    <el-table-column
                            prop="content"
                            align="center"
                            label="修改时间"
                            width="155">
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                currentPage:1,
                pageSize:10,
                tableList:[]
            }
        },
        created() {
            this.getQuestionList();
        },
        activated() {
            this.getQuestionList();
        },
        methods:{
            //获取列表数据
            getQuestionList(){
                this.$http.post('/question-help/list',{
                    page: this.currentPage,
                    rows: this.pageSize,
                    filter: {
                        key:''
                    },
                    searchKey: '',
                    orderBy: 'create_time desc'
                }).then(res=>{
                    this.tableList = res.data.rows;
                })
            },
            //查看
            toDetail(row){
                this.$router.push({path:`/questionDiscretion/detail/${row.id}`})
            },
            //新增
            addData(){
                this.$router.push({path:`/questionDiscretion/exit/add`})
            },
            //编辑
            toQuestionExit(row){
                this.$router.push({path:`/questionDiscretion/exit/${row.id}`})
            },
            //更改发布状态
            publishToPage(row,title){
                this.$http.put('/question-help/publish/'+row.id).then(res=>{
                    if(res.data.code == 1){
                        this.$notify({
                            title: title,
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'success'
                        })
                        row.publishFlag = !row.publishFlag;
                    }else{
                        this.$notify({
                            title: title,
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        })
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    header{
        height: 68px;
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        .header-title {
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px 0 0;
            p {
                font-size: 18px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin-left: 32px;
            }
        }
    }
.container{
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    margin-top: 20px;
    .card-content-search{
        display: flex;
        justify-content: flex-end;
        padding: 10px 0 20px;
        .card-content-search-add {
            width: 82px;
            height: 32px;
            background: #1890FF;
            border: none;
            border-radius: 2px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            cursor: pointer;
            line-height: 32px;
            margin-left: 12px;
        }
    }
}
</style>